import colors from "shared/styles/colors";
import { IVariantProps, ThemeType } from "shared/styles/theme";
import styled, { css } from "styled-components";
import theme from "styled-theming";
import { device } from "../../styles/helpers";

export enum ButtonType {
    solid = "solid",
    bordered = "bordered",
    dark = "dark",
    text = "text"
}

export enum TabButtonType {
    normal = "normal",
    selected = "selected"
}

const buttonBackgroundColorDarkStyles = {
    [ThemeType.light]: colors.purpleTertiary,
    [ThemeType.dark]: colors.grey_1
}

const buttonColorDarkStyles = {
    [ThemeType.light]: colors.purpleDark,
    [ThemeType.dark]: colors.white
}

const buttonBorderDarkStyles = {
    [ThemeType.light]: "none",
    [ThemeType.dark]: "none"
}

export const buttonBackgroundColorDark = theme("mode", buttonBackgroundColorDarkStyles)
export const buttonColorDark = theme("mode", buttonColorDarkStyles)
export const buttonBorderDark = theme("mode", buttonBorderDarkStyles)

export const buttonBackgroundColor = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: colors.purpleBackground,
        [ThemeType.dark]: colors.grey_1
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.transparent
    },
    [ButtonType.dark]: buttonBackgroundColorDarkStyles,
    [ButtonType.text]: {
        [ThemeType.light]: colors.transparent,
        [ThemeType.dark]: colors.transparent
    }
});

export const buttonColor = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.dark]: buttonColorDarkStyles,
    [ButtonType.text]: {
        [ThemeType.light]: colors.black,
        [ThemeType.dark]: colors.white
    }
});

export const buttonBorder = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: "none",
        [ThemeType.dark]: "none"
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: `2px solid ${colors.purpleBackground}`,
        [ThemeType.dark]: `2px solid ${colors.grey_1}`
    },
    [ButtonType.dark]: buttonBorderDarkStyles,
    [ButtonType.text]: {
        [ThemeType.light]: "none",
        [ThemeType.dark]: "none"
    }
});

export const buttonHeight = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: "40px",
        [ThemeType.dark]: "40px"
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: `40px`,
        [ThemeType.dark]: `40px`
    },
    [ButtonType.dark]: {
        [ThemeType.light]: "40px",
        [ThemeType.dark]: "40px"
    },
    [ButtonType.text]: {
        [ThemeType.light]: "auto",
        [ThemeType.dark]: "auto"
    }
});


export const buttonBackgroundColorHover = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: colors.purpleTertiary,
        [ThemeType.dark]: colors.grey_1
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: colors.purpleBackground,
        [ThemeType.dark]: colors.grey_1
    },
    [ButtonType.dark]: {
        [ThemeType.light]: colors.purpleSecondary,
        [ThemeType.dark]: colors.dark
    },
    [ButtonType.text]: {
        [ThemeType.light]: colors.transparent,
        [ThemeType.dark]: colors.transparent
    }
});

export const buttonColorHover = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.dark]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.text]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    }
});

export const buttonBorderHover = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: "none",
        [ThemeType.dark]: "none"
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: `2px solid ${colors.purpleTertiary}`,
        [ThemeType.dark]: `2px solid ${colors.grey_1}`
    },
    [ButtonType.dark]: {
        [ThemeType.light]: "none",
        [ThemeType.dark]: "none"
    },
    [ButtonType.text]: {
        [ThemeType.light]: "none",
        [ThemeType.dark]: "none"
    }
});

export const buttonColorActive = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.dark]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white
    },
    [ButtonType.text]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.white
    }
});

export const buttonBorderRadiusActive = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: "35px",
        [ThemeType.dark]: "35px"
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: "35px",
        [ThemeType.dark]: "35px"
    },
    [ButtonType.dark]: {
        [ThemeType.light]: "35px",
        [ThemeType.dark]: "35px"
    },
    [ButtonType.text]: {
        [ThemeType.light]: "none",
        [ThemeType.dark]: "none"
    }
});

export const buttonColorDisabled = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: colors.darkPurpleTagBorder,
        [ThemeType.dark]: colors.dark2
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: colors.darkPurpleTagBorder,
        [ThemeType.dark]: colors.dark2
    },
    [ButtonType.dark]: {
        [ThemeType.light]: colors.darkPurpleTagBorder,
        [ThemeType.dark]: colors.dark2
    },
    [ButtonType.text]: {
        [ThemeType.light]: colors.darkPurpleTagBorder,
        [ThemeType.dark]: colors.dark2
    }
})

export const buttonBackgroundAndBorderColorDisabled = theme.variants("mode", "variant", {
    [ButtonType.solid]: {
        [ThemeType.light]: colors.notGreenGrey,
        [ThemeType.dark]: colors.dark4
    },
    [ButtonType.bordered]: {
        [ThemeType.light]: colors.notGreenGrey,
        [ThemeType.dark]: colors.dark4
    },
    [ButtonType.dark]: {
        [ThemeType.light]: colors.notGreenGrey,
        [ThemeType.dark]: colors.dark4
    },
    [ButtonType.text]: {
        [ThemeType.light]: colors.notGreenGrey,
        [ThemeType.dark]: colors.dark4
    }
})

const tabButtonColor = theme.variants("mode", "variant", {
    [TabButtonType.normal]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.grey_4
    },
    [TabButtonType.selected]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.black
    }
})

const tabButtonBackgroundColor = theme.variants("mode", "variant", {
    [TabButtonType.normal]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.dark
    },
    [TabButtonType.selected]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.grey_4
    }
})

const tabButtonBorderColor = theme.variants("mode", "variant", {
    [TabButtonType.normal]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.grey_4
    },
    [TabButtonType.selected]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.grey_4
    }
})

const tabButtonBackgroundColorHover = theme.variants("mode", "variant", {
    [TabButtonType.normal]: {
        [ThemeType.light]: colors.purpleTertiary,
        [ThemeType.dark]: colors.dark2
    },
    [TabButtonType.selected]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.grey_4
    }
})

const tabButtonHeight = theme.variants("mode", "variant", {
    [TabButtonType.normal]: {
        [ThemeType.light]: "40px",
        [ThemeType.dark]: "40px"
    },
    [TabButtonType.selected]: {
        [ThemeType.light]: "44px",
        [ThemeType.dark]: "44px"
    },
})

const tabButtonMarginTop = theme.variants("mode", "variant", {
    [TabButtonType.normal]: {
        [ThemeType.light]: "0",
        [ThemeType.dark]: "0"
    },
    [TabButtonType.selected]: {
        [ThemeType.light]: "-4px",
        [ThemeType.dark]: "-4px"
    },
})

export const ButtonBaseStyles = css<IButtonStyledProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    width: fit-content;
    font-weight: 400;
    font-family: "Gilroy-Medium", "medium-fallback";
    background-color: ${buttonBackgroundColor};
    color: ${buttonColor} !important;
    border-radius: 15px;
    text-decoration: none;
    border: ${buttonBorder};
    transition: all .2s;

    svg path {
            fill: ${buttonColor} !important;
    }

    &:hover {
        &:not(:disabled){
            cursor: pointer;
       
            span {
                ${props => props.variant === 'text' ? css`
                    text-decoration: underline;
                `: css`
                    text-decoration: none;
                `}
            }
        }
        background-color: ${buttonBackgroundColorHover};
        color: ${buttonColorHover} !important;
        border: ${buttonBorderHover};
    }
    &:active {
        color: ${buttonColorActive} !important;
        &:not(:disabled){
            border-radius: ${buttonBorderRadiusActive};
        }
    }
    &:disabled {
        cursor: not-allowed;
        color: ${buttonColorDisabled} !important;
        background-color: ${buttonBackgroundAndBorderColorDisabled};

        svg path {
            fill: ${buttonColorDisabled} !important;
        }
    }

    @media ${device.laptop} {
        font-size: 1rem;
    }
    @media ${device.laptopL} {
        font-size: var(--header-4-font-size);
    }
    ${props => props.$noPadding ? css`
        padding: 0px;
    ` : css`
        padding: 0px 25px;
    `}
`

export const Button = styled.button<IButtonStyledProps>`
    ${ButtonBaseStyles};
`
export const ButtonIcon = styled.i`
    margin-right: 10px;
    margin-left: -5px;
`;


export const ButtonGroup = styled.div<IButtonGroupProps>`
    display: flex;
    gap: ${props => props.gap ? `${props.gap}px` : "unset"};
    ${props => props.margin && css`
        margin: ${props.margin};
    `}
    ${props => props.separate && css`
        justify-content: space-between;
    `}
    ${props => props.centerItems && css`
        align-items: center;
    `}
    ${props => props.asColumn && css`
        flex-direction: column;
    `}
    ${props => props.$wrap && css`
        flex-wrap: wrap;
    `}
    ${props => props.$justifyContentEnd && css`
        justify-content: flex-end;
    `}
`

export const TabButton = styled.button<IVariantProps<TabButtonType>>`
    color: ${tabButtonColor};
    background-color: ${tabButtonBackgroundColor};
    border: 2px solid ${tabButtonBorderColor};
    border-bottom: none;
    height: ${tabButtonHeight};
    width: 75px;
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
    margin-top: ${tabButtonMarginTop};
    text-decoration: none;
    transition: all .2s;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
        font-size: var(--header-3-font-size);
        font-weight: 400;
        font-family: "Gilroy-Medium", "medium-fallback";
    }
    &:hover {
        cursor: pointer;
        background-color: ${tabButtonBackgroundColorHover};
    }
`


export enum BackButtonVariant {
    default = "default",
    purple = "purple"
}

const BackButtonColor = theme.variants("mode", "variant", {
    [BackButtonVariant.default]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.white,
    },
    [BackButtonVariant.purple]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.purpleTertiary,
    }
})

export const BackButton = styled.span<IVariantProps<BackButtonVariant>>`
    font-size: var(--header-3-font-size);
    font-weight: 500;
    text-align: center;
    font-family: "Gilroy-Medium", "medium-fallback";
    width: 100px;
    display: inline-block;
    padding-bottom: 12px;
    color: ${BackButtonColor};
    border-bottom: solid 2px ${BackButtonColor};
    position: relative;
    &:after {
        border-bottom: 5px solid transparent;
        border-right: 9px solid  ${BackButtonColor};
        border-top: 5px solid transparent;
        bottom: -6px;
        content: "";
        height: 0;
        position: absolute;
        left: -4px;
        width: 0;      
    }
`
export const MiniButton = styled.button<IVariantProps<ButtonType>>`
    display: flex;
    flex-direction: row;
    height: 20px;
    font-weight: 500;
    font-family: "Gilroy-Regular", "regular-fallback";
    background-color: ${buttonBackgroundColor};
    color: ${buttonColor};
    border: ${buttonBorder};
    border-radius: 7px;
    text-decoration: none;
    transition: all .2s;
    pointer-events: auto;
    &:hover {
        cursor: pointer;
        background-color: ${buttonBackgroundColorHover};
        color: ${buttonColorHover};
        border: ${buttonBorderHover};
    }
    &:active {
        color: ${buttonColorActive};
        border-radius: ${buttonBorderRadiusActive};
    }
`

export const FileInputLabel = styled.label`
    ${ButtonBaseStyles};
`

export const RightSplitButtonStyles = css<IButtonStyledProps>`
    ${ButtonBaseStyles};
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
`

export const RightSplitButton = styled.button<IButtonStyledProps>`
    ${RightSplitButtonStyles};
`

export const LeftSplitButton = styled.button<IButtonStyledProps>`
    ${ButtonBaseStyles};
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    padding: 0 20px 0 15px !important;
`

export interface IButtonStyledProps extends IVariantProps<ButtonType> {
    $noPadding?: boolean;
}

interface IButtonGroupProps {
    gap?: number;
    margin?: string;
    separate?: boolean;
    centerItems?: boolean;
    asColumn?: boolean;
    $wrap?: boolean;
    $justifyContentEnd?: boolean;
}

Button.defaultProps = {
    variant: ButtonType.solid
};


TabButton.defaultProps = {
    variant: TabButtonType.normal
}

MiniButton.defaultProps = {
    variant: ButtonType.bordered
}